export default function getRouteAction(actionLink?: string) {
  if (!actionLink) {
    return "";
  }
  actionLink = actionLink.replace("/sv", "");
  actionLink = actionLink.split("?")[0]; // Remove query parameters
  actionLink = ((actionLink.startsWith("/") ? "" : "/") + actionLink).slice(1);
  actionLink = (actionLink + (actionLink.endsWith("/") ? "" : "/")).slice(0, -1);
  let arr = actionLink.split("/");

  if (arr.length >= 2) {
    arr = arr.slice(1);
  }

  const routeAction = arr.join("-").toLowerCase();
  return routeAction;
}
